export default import.meta.ROLLUP_FILE_URL_2h$eqWdLjjj$zuUvyPi$HQ;